import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChangePWComponent } from './changepw.component';
import { PsI18nModule } from '../../pf.core/i18n/psi18n.module';
import { SmartadminValidationModule } from '../../shared/forms/validation/smartadmin-validation.module';
import { ModalModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { I18nModule } from '../../shared/i18n/i18n.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SmartadminValidationModule,
    PsI18nModule,
    I18nModule,
    ModalModule
  ],
  declarations: [ChangePWComponent],
  exports: [ChangePWComponent]
})
export class ChangePWModule { }


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/changepw/changepw.module.ts